/*
 * @Description: 结算单管理
 * @Author: 杨志航
 * @Date: 2026-05-14 09:59:34
 */
const billManage = {
  // 结算方式列表
  getSettlementMethodList: {
    url: '/fortune/SettlementMethod/list',
    method: 'get'
  },
  // 结算方式导入
  importSettlementMethod: {
    url: '/fortune/SettlementMethod/import',
    method: 'post'
  },
  // 结算方式导出
  getSettlementMethodExportTpl: {
    url: '/fortune/SettlementMethod/GetExportTpls',
    method: 'get'
  },
  exportSettlementMethod: {
    url: '/fortune/SettlementMethod/Export',
    method: 'post'
  },
  getSettlementMethodTplItems: {
    url: '/fortune/SettlementMethod/GetExportFields',
    method: 'get'
  },
  saveSettlementMethodLevelTpl: {
    url: '/fortune/SettlementMethod/SaveExportTpls',
    method: 'post'
  },
}

export default billManage